export const lightMapStyle = "mapbox://styles/mpilarczykstarcount/cm0tlhqzz00rk01o30mhhh3sp"
export const darkMapStyle = "mapbox://styles/mpilarczykstarcount/cm0qr47xx00ns01qkdt8ud9se"
